
import { BehaviorSubject } from 'rxjs';

export const behaviorBundleElements$ = new BehaviorSubject({});

export const behaviorBundleElements = behaviorBundleElements$.asObservable();